
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/form/[uid]",
      function () {
        return require("private-next-pages/form/[uid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/form/[uid]"])
      });
    }
  